import React from 'react';

type Props = {
  className?: string;
  children?: React.ReactNode;
  prefix?: string;
};

export const CurrencyFormatter = new Intl.NumberFormat('fi-FI', {
  style: 'currency',
  currency: 'EUR',
});

export const Currency: React.FC<Props> = ({ children, prefix, className, ...props }) => {
  if (children === undefined) {
    return null;
  }

  if (typeof children !== 'number') {
    // throw new Error(`Currency children must be number, got '${children}'`);
    return null;
  }

  const value = children as number;

  return (
    <div className={className} {...props}>
      {prefix && <span>{prefix}</span>}
      {CurrencyFormatter.format(value)}
    </div>
  );
};
